import { SharedConstants } from "../constants/shared.constants";
export class FeatureServiceUtils {
    static GetSystemAttributeNames(alias) {
        switch (alias.toLowerCase()) {
            case "created_user":
                alias = SharedConstants.CREATED_USER_LABEL;
                break;
            case "created_date":
                alias = SharedConstants.CREATED_DATE_LABEL;
                break;
            case "last_edited_user":
                alias = SharedConstants.LAST_EDITED_USER_LABEL;
                break;
            case "last_edited_date":
                alias = SharedConstants.LAST_EDITED_DATE_LABEL;
                break;
        }
        return alias;
    }
    static GetCodedDomainValue(domainValues, name, value) {
        let returnVal = value;
        // @ts-ignore
        if (domainValues && domainValues.length > 0) {
            // @ts-ignore
            domainValues.forEach((domain) => {
                // @ts-ignore
                if (domain.attribute === name) {
                    // @ts-ignore
                    domain.codedValues.forEach((keyPair) => {
                        if (keyPair.code === value) {
                            returnVal = keyPair.name;
                            return;
                        }
                    });
                }
            });
        }
        return returnVal;
    }
    static PropertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
}
